var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.cards),function(item){return _c('irsh-card',{key:item.path,class:_vm.cardClass,attrs:{"card":item,"header-type":_vm.cardHeaderType}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }